module.exports = require('./helpers/bundle-url').getBundleURL('lKZFx') + "logo.7718c6df.svg";